import { cn } from '@/shadcn-ui/utils';

interface ChevronDownProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

export default function ChevronDropdown({
  width = 24,
  height = 24,
  fill = 'fill-flexcar-neutral10',
  className,
}: ChevronDownProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={cn(fill, className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.29289 9.29302C6.68342 8.90249 7.31658 8.90249 7.70711 9.29302L12 13.5859L16.2929 9.29302C16.6834 8.90249 17.3166 8.90249 17.7071 9.29302C18.0976 9.68354 18.0976 10.3167 17.7071 10.7072L12.7071 15.7072C12.3166 16.0978 11.6834 16.0978 11.2929 15.7072L6.29289 10.7072C5.90237 10.3167 5.90237 9.68354 6.29289 9.29302Z"
      />
    </svg>
  );
}
